function getScoreLevel(score: number): 'high' | 'medium' | 'low' {
  if (score >= 80) return 'high';
  if (score >= 50) return 'medium';
  return 'low';
}

const LEVEL_COLORS = {
  high: 'var(--success-dark)',
  medium: 'var(--warning)',
  low: 'var(--destructive)',
} as const;

interface ScoreBarProps {
  score: number;
  maxWidth?: number;
}

export function ScoreBar({ score, maxWidth }: ScoreBarProps) {
  const level = getScoreLevel(score);
  const color = LEVEL_COLORS[level];

  return (
    <div className="flex items-center gap-2" style={{ maxWidth }}>
      <div
        className="flex-1 overflow-hidden rounded-[3px]"
        style={{ height: 6, backgroundColor: 'var(--background-muted)' }}
      >
        <div
          className="h-full rounded-[3px] transition-all duration-400"
          style={{ width: `${score}%`, backgroundColor: color }}
        />
      </div>
      <span
        className="text-[0.6875rem] font-semibold"
        style={{ minWidth: 32, textAlign: 'right', color }}
      >
        {Math.round(score)}%
      </span>
    </div>
  );
}
